import type { Ride } from '../domain/ride';
import { browserUuid } from '../domain/browser-crypto';
import { isRecordedRideSource } from '../../../renderer/src/ride-source';
import { API,apiRequest,jsonPost,ApiError } from './api-client';

const saved=new Map<string,{rideId:string;uploadId?:string | undefined}>();
const pendingImports=new WeakMap<Ride,{key:string;uploadId?:string}>();
export const savedAccountRide=(id:string)=>saved.get(id);
export const rememberAccountRide=(id:string,rideId:string)=>saved.set(id,{rideId});

/** Saves signed-in recorded imports independently of video export, retaining FIT originals. */
export async function saveAccountImport(file:File,ride:Ride) {
  if(!isRecordedRideSource(ride.source))return false;
  let account:{initialized:boolean;canImport:boolean};
  try {account=await apiRequest(`${API}/account/entitlements`);} catch(error) {
    if(error instanceof ApiError && ![401,403,404,503].includes(error.status))throw error;
    return false;
  }
  if(!account.initialized)return false;
  if(!account.canImport)throw new Error('Your current account access does not allow new imports.');
  let pending=pendingImports.get(ride);
  if(!pending){pending={key:browserUuid()};pendingImports.set(ride,pending);}
  const key=pending.key;
  if(ride.source==='fit'&&!pending.uploadId){
    const upload=await apiRequest<{id:string}>(`${API}/uploads`,{method:'POST',headers:{'Content-Type':'application/octet-stream','X-Filename':encodeURIComponent(file.name),'Idempotency-Key':key},body:file});
    pending.uploadId=upload.id;
  }
  const {id,title,region,source,sourceFileName,recordingDevice,points,sourcePoints}=ride;
  const stored=await apiRequest<{rideId:string}>(`${API}/rides`,jsonPost({id,title,region,source,sourceFileName,recordingDevice,points:sourcePoints??points,uploadId:pending.uploadId,importRequestKey:key}));
  saved.set(ride.id,{rideId:stored.rideId,uploadId:pending.uploadId});
  pendingImports.delete(ride);
  await apiRequest(`${API}/activity`,jsonPost({kind:'preview_started',sourceId:browserUuid(),uploadId:pending.uploadId})).catch(()=>undefined);
  return true;
}

export async function recordRejectedImport(filename:string) {
  await apiRequest(`${API}/activity`,jsonPost({kind:'import_rejected',sourceId:browserUuid(),filename:filename.slice(0,240)})).catch(()=>undefined);
}
